import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import FileUtil from '../../helpers/FileUtil/FileUtil';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import dataModel from '../../models/DataModel';

// Change Card to the appropriate name
export class Download extends BaseComponent {
  constructor(props) {
    super(props);
    this.state ={
      downloadName: props.download,
    };

    //initialize analytics
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  handleDownloadClick(){
    if (!this.props.activitiesList) {
      this.props.activityLogsDataModel.getActivitiesList(activitiesList => {
        this.handleLogDownload(activitiesList);
      });
    }
    else {
      this.handleLogDownload(this.props.activitiesList);
    }
  }

  handleLogDownload(activitiesList) {
    const body = `${this.props.currentUser.name} downloaded ${this.state.downloadName}.`;
    let activitySubType = null;
    activitiesList.filter(activity => {
      let activity_sub_type = activity.activity_sub_types.filter(subType => {
        return subType.name == 'Download';
      });
      if (activity_sub_type.length > 0) {
        activitySubType = activity_sub_type[0];
      }
      return true;
    });
    this.props.activityLogsDataModel.eventHistories = { create: { activity_sub_type: activitySubType, body: body } };
    if(!!this.props.isReferenceDocument) {
      const fileType = FileUtil.getExtension(this.props.download);
      this.analyticsLogger.logRDLDownloadEvent(fileType);
    }
  }

  render() {
    const { download, href, className, content } = this.props;

    return (
      <a className={className} download={download} href={href} onClick={this.handleDownloadClick}>
        {content}
      </a>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,    
    activityLogsDataModel: dataModel.activityLogsDataModel,
    activitiesList: state.activityLogs.activitiesList,
  };
};

export default connect(mapStateToProps)(Download);



// WEBPACK FOOTER //
// ./src/components/Download/index.js